<template>
  <div class="tabla-riesgos">
    <el-table :key="render" :data="risks" :default-sort="{ prop: 'mfl', order: 'descending' }"
      style="width: 100%; border: 10px; border-collapse: separate" :cell-class-name="pintar"
      header-cell-class-name="header-cell-class-table-gray">
      <el-table-column fixed type="expand" width="40" label="+">
        <template slot-scope="props" v-if="!props.row.tipo || filtro_tipo_riesgo[props.row.tipo.toLowerCase()]
          ">
          <div style="
              padding-left: 30px;
              padding-right: 30px;
              padding-bottom: 20px;
            ">
            <el-row :gutter="20">
              <el-col :sm="8">
                <h4>{{ $t("Causas") }}</h4>
                <ol>
                  <li v-for="(causa, ic) in props.row.causas" :key="ic">
                    {{ causa.nombre }}
                  </li>
                </ol>
              </el-col>
              <el-col :sm="8">
                <h4>{{ $t("Controles Preventivos") }}</h4>
                <ol>
                  <li v-for="(control, ic) in getControlesPreventivos(props.row)" :key="ic"
                    :class="tablaControlCritico(control)">
                    {{ control.nombre }}
                  </li>
                </ol>
              </el-col>
              <el-col :sm="8">
                <h4>{{ $t("Controles Mitigatorios") }}</h4>
                <ol>
                  <li v-for="(control, ic) in getControlesMitigadores(props.row)" :key="ic"
                    :class="tablaControlCritico(control)">
                    {{ control.nombre }}
                  </li>
                </ol>
              </el-col>
            </el-row>
            <div v-if="props.row.medioambiental || props.row.medioambiente">
              <h4>{{ $t("Información Medioambiental") }}</h4>
              <el-row :gutter="20">
                <el-col :sm="12">
                  <h5>{{ $t("Responsable") }}</h5>
                  {{ props.row.medioambiente.responsable }}
                  <h5>{{ $t("Condición") }}</h5>
                  {{ props.row.medioambiente.condicion }}
                  <h5>{{ $t("Aspecto Ambiental") }}</h5>
                  {{ props.row.medioambiente.aspecto }}
                </el-col>
                <el-col :sm="12">
                  <h5>{{ $t("Evento") }}</h5>
                  {{ props.row.medioambiente.evento }}
                  <h5>{{ $t("Equipo Crítico") }}</h5>
                  {{ props.row.medioambiente.equipo }}
                  <h5>{{ $t("Evaluación Aspecto Ambiental") }}</h5>
                  <el-tag :type="getMayorImpacto(props.row).mfl >= 3 ? 'danger' : 'success'
                    ">
                    {{
                      getMayorImpacto(props.row).mfl >= 3
                      ? $t("Significativo")
                      : $t("No Significativo")
                    }}
                  </el-tag>
                </el-col>
              </el-row>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed :label="$t('Acción')" v-if="this.$store.getters.inventario.status == 2 &&
          isActiveContract(contract) && !$store.getters.user.readonly
          " width="230">
        <template slot-scope="scope">
          <el-button v-if="['coordinator', 'contractor_coordinator'].includes($store.getters.role.role)" type="warning" size="small" @click="copyRisks(scope.row)">{{ $t("Copiar a otro inventario")
          }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column fixed :label="$t('Acción')" v-if="this.$store.getters.inventario.status == 1 &&
        isActiveContract(contract) && !$store.getters.user.readonly
        " width="230">
        <template slot-scope="scope">
          <div v-if="$store.getters.role.admin ||
            $store.getters.role.role === 'coordinator' ||
            $store.getters.role.role === 'contractor_coordinator'
            ">
            <el-button size="small" icon="el-icon-delete" type="danger" class="buttonAction"
              @click="deleteRisk(scope.row)">{{ $t("Eliminar") }}</el-button>
          </div>
          <div>
            <el-button size="small" v-if="($store.getters.role.admin && scope.row.custom === true) ||
              (['health', 'safety', 'environment'].includes(
                $store.getters.role.role
              ) &&
                scope.row.custom === true &&
                canReviewRisk(scope.row)) ||
              (['coordinator', 'contractor_coordinator'].includes(
                $store.getters.role.role
              ) &&
                scope.row.custom === true &&
                [-1, '-1'].includes(scope.row.status_step))
              " icon="el-icon-edit" type="primary" class="buttonAction"
              @click="changeRisk(scope.row)">{{ $t("Modificar") }}
            </el-button>
          </div>

          <div>
            <el-button size="small" v-if="($store.getters.role.admin && scope.row.custom === true) ||
              (['health', 'safety', 'environment'].includes(
                $store.getters.role.role
              ) &&
                scope.row.custom === true &&
                canReviewRisk(scope.row)) ||
              ['coordinator', 'contractor_coordinator'].includes(
                $store.getters.role.role
              )
              " icon="el-icon-refresh" type="primary" class="buttonAction"
              @click="openChangeEstandarizado(scope.row)">{{ $t("Cambiar por estandarizado") }}</el-button>
          </div>
          <div>
            <el-button v-if="$store.getters.role.admin || ['coordinator', 'contractor_coordinator'].includes($store.getters.role.role)" class="buttonAction" type="warning" size="small" @click="copyRisks(scope.row)">{{ $t("Copiar a otro inventario")}}</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Riesgo')" min-width="220">
        <template slot-scope="scope">
          <div v-if="scope.row.custom === false || !scope.row.custom" class="nombre-riesgo">
            {{ scope.row.nombre }} /
            <span style="color: red">{{
              faenas[$store.getters.role.faena_id]
            }}</span>
          </div>
          <div v-else class="nombre-riesgo">{{ scope.row.nombre }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Estandarizado')" width="120" align="center">
        <template slot-scope="scope">
          <i class="el-icon-success" v-if="scope.row.custom === false || !scope.row.custom"
            style="color: green; font-size: 25px !important"></i>
          <span v-else>N/A</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Tipo Impacto')" width="130" align="center">
        <template slot-scope="scope">{{
          getMayorImpacto(scope.row).impacto ? getMayorImpacto(scope.row).impacto.categoria : "Pendiente"
        }}</template>
      </el-table-column>
      <el-table-column label="MFL" prop="mfl" align="center" sortable :sort-method="sortMFL">
        <template slot-scope="scope">
          <el-popover placement="top-start" width="400" trigger="hover" :content="nivelSeveridad[getMayorImpacto(scope.row).mfl]
            ? nivelSeveridad[getMayorImpacto(scope.row).mfl][
            validarTipoImpacto(scope.row)
            ]
            : ''
            ">
            <div slot="reference" class="full-content" v-bind:type="mflRange(getMayorImpacto(scope.row).mfl)">
              {{ getMayorImpacto(scope.row).mfl }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="FS" align="center" width="110">
        <template slot-scope="scope">
          <el-popover placement="top-start" width="800" trigger="hover" :content="getContentFS(getMayorImpacto(scope.row), scope.row)">
            <div class="full-content" slot="reference">
              {{ getMayorImpacto(scope.row).impacto ? getMayorImpacto(scope.row).impacto.factor_severidad : "Pendiente" }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="FP" align="center" width="110">
        <template slot-scope="scope">
          <el-popover placement="top-start" width="400" trigger="hover" :content="getContentFP(getMayorImpacto(scope.row), scope.row)">
            <div class="full-content" slot="reference">
              {{ getMayorImpacto(scope.row).impacto ? getMayorImpacto(scope.row).impacto.factor_probabilidad : "Pendiente" }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="RRR" align="center">
        <template slot-scope="scope">
          <span>{{ getMayorImpacto(scope.row).rrr }}</span>
        </template>
      </el-table-column>
      <el-table-column label="NSR" align="center" width="110">
        <template slot-scope="scope">{{
          getMayorImpacto(scope.row).impacto ? getMayorImpacto(scope.row).impacto.nivel_severidad : "Pendiente"
        }}</template>
      </el-table-column>
      <el-table-column v-if="withStatus" :label="$t('Último Estado')" align="center" width="215">
        <template slot-scope="scope">
          <div v-if="scope.row.custom && $store.getters.inventario.status != 3">
            <button v-if="scope.row.status == 0 && scope.row.status_step != -1" class="btn_show_history_risk yellow"
              @click="ShowDialogHistoryRisk(scope.row)">
              {{ $t("En Revisión") }}
            </button>
            <el-tag v-if="scope.row.status == 0 && scope.row.status_step == -1" type="warning">{{ $t("Necesita arreglo")
            }}</el-tag>

            <button v-if="scope.row.status == 1" class="btn_show_history_risk green"
              @click="ShowDialogHistoryRisk(scope.row)">
              {{ $t("Aprobado") }}
            </button>
            <p v-if="scope.row.status_by" class="statusUpdatedAt" :title="$t('Persona que revisó riesgo por última vez')">
              <span style="font-size: 12px">
                <b>Últimos revisores</b>
              </span>
              <br />
              <i class="el-icon-d-arrow-right"></i>
              {{ getPerfil(scope.row.status_position) }}
              <br />
              {{ scope.row.status_by }}
              <br />
              {{ scope.row.status_updated_at | moment("DD MMM YYYY HH:mm") }}
            </p>
            <p class="statusUpdatedAt" :title="$t('Persona que le toca revisar riesgo')">
              <span style="font-size: 12px">
                <b>Próximos revisores</b>
              </span>
              <br />
              <span v-html="nextReviewer(scope.row)"></span>
            </p>
          </div>
          <div v-else class="no-aplica">{{ $t("No aplica") }}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="withStatus" label="Comentarios" min-width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.custom">
            <div @click="verComentarios(scope.row.status_message)" v-if="scope.row.status_message"
              style="max-height: 300px; overflow: auto; cursor: pointer">
              <p style="font-size: 12px" v-html="scope.row.status_message"></p>
            </div>
            <span class="no-aplica" v-else>{{ $t("Sin comentarios") }}</span>
          </div>
          <div v-else class="no-aplica">{{ $t("No aplica") }}</div>
        </template>
      </el-table-column>
      <el-table-column label="PDF" v-if="this.$store.getters.inventario.status == 2 ||
        this.$store.getters.inventario.status == 3
        " align="center" width="200">
        <template slot-scope="scope">
          <div class="text-center">
            <el-button class="button_img" size="small" @click="imprimirTabla(scope.row._id)" :loading="isLoadingPDFTabla">
              <img class="img_pdf" src="@/assets/icons/pdf.png" />
              <br />
              <span>{{ $t("Vista tabla") }}</span>
            </el-button>
            <el-button class="button_img" size="small" @click="imprimirBowtie(scope.row._id)"
              :loading="isLoadingPDFBowtie">
              <img class="img_pdf" src="@/assets/icons/pdf.png" />
              <br />
              <span>{{ $t("Vista bowtie") }}</span>
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" v-if="this.$store.getters.inventario.status == 1 && !$store.getters.user.readonly"
        label="Selección" align="center" width="200">
        <template slot-scope="scope">
          <el-button icon="el-icon-success" style="margin-bottom: 10px" size="small"
            :type="validRevision(scope.row, 'aprobar') ? 'success' : 'info'" v-if="canReviewRisk(scope.row) &&
              $store.getters.role.faena_id === '5a6f78337b772dcfe68241d5'
              " @click="revisar(scope.row, 'aprobar')">
            Aprobar Riesgo
          </el-button>
          <br />
          <el-button icon="el-icon-error" size="small" :type="validRevision(scope.row, 'rechazar') ? 'danger' : 'info'"
            v-if="canReviewRisk(scope.row) && !$store.getters.user.readonly" @click="revisar(scope.row, 'rechazar')">
            Rechazar Riesgo
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :before-close="closeDialogVerificarEstado" width="30%" :title="$t('REVISIÓN')"
      :visible="dialogVerificarEstado" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <el-form :model="status">
        <div>
          <el-form-item :label="$t('Estado')">
            <el-select :class="{
              aprueba: status.status_step === 'true',
              rechaza: status.status_step === 'false',
            }" v-model="status.status_step" :placeholder="$t('Por favor revise el riesgo')" size="large"
              class="with-help-box fullWidth">
              <el-option style="background-color: green; color: white" :label="$t('Revisado (Aprobar)')"
                value="true"></el-option>
              <el-option style="background-color: red; color: white" :label="$t('Revisado con comentarios (Rechazar)')"
                value="false"></el-option>
            </el-select>
            <el-popover class="help-box" placement="top" :title="$t('Estado')" width="200" trigger="hover" :content="$t(
              'Seleccione el estado de aprobación del riesgo. Si no aprueba la evaluación del riesgo, debe seleccionar \'Revisado con comentarios\'.'
            )
              ">
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
          <el-form-item :label="$t('Seleccione observaciones')" v-if="status.status_step === 'false'">
            <el-select class="with-help-box fullWidth" v-model="acciones" multiple placeholder="Seleccione observaciones">
              <el-option v-for="item in opciones_comentarios" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Observaciones adicionales" v-if="status.status_step === 'false'">
            <el-input class="with-help-box" type="textarea" :rows="2" v-model="status.message" />
            <el-popover class="help-box" placement="top" title="Observaciones adicionales" width="200" trigger="hover"
              :content="$t(`Especifique el motivo del rechazo del riesgo para que
              el  \'Coordinador \' corrija el riesgo.`)
                ">
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogVerificarEstado()">{{
          $t("Cancelar")
        }}</el-button>
        <el-button type="primary" @click="saveVerificarEstado()">{{
          $t("Guardar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :before-close="closeChangeRisk" :title="$t('Modificando Riesgo o Aspecto Ambiental')" width="90%"
      :visible="dialogChangeRiskVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <p>
        {{ $t("A continuación puede modificar el riesgo según lo indicado por el revisor. Por favor, verifique bien antes de guardar.") }}
      </p>
      <InventarioBowtie :dataHistory="dataHistory" :editable="true" :risk="this.actualRisk" :addCause="addCause"
        :deleteCause="deleteCause" :editCause="editCause" :addImpact="addImpact" :deleteImpact="deleteImpact"
        :editImpact="editImpact" :addPreventiveControl="addPreventiveControl"
        :deletePreventiveControl="deletePreventiveControl" :editPreventiveControl="editPreventiveControl"
        :addMitigationControl="addMitigationControl" :deleteMitigationControl="deleteMitigationControl"
        :editMitigationControl="editMitigationControl" :addEvaluator="addEvaluator" :deleteEvaluator="deleteEvaluator"
        :editEvaluator="editEvaluator" />

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeChangeRisk()">{{ $t("Cancelar") }}</el-button>
        <el-button type="primary" @click="saveRisk()">{{
          $t("Guardar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :before-close="handleClose" handle width="70%" :visible="dialogHistoryRiskVisible">
      <div class="dialog_show_history_risk">
        <span class="color_orange font-title">
          <b>{{ $t("Historial del Riesgo") }}</b>
        </span>
        <br />
        <b>Nombre del riesgo:</b>
        {{ $t(nombreRiesgo) }}
        <br />
        <b>Último usuario en revisar:</b>
        {{ ultimoRevisor }}
        <br />
        <b>Fecha última revisión:</b>
        {{ fechaUltimaRevision | moment("DD MMM YYYY HH:mm") }}
        <br />
        <br />
        <div class="HistoryRisk_container">
          <HistoryRisk :ultimoRevisor="ultimoRevisor" :fechaUltimaRevision="fechaUltimaRevision"
            :revisores_history="revisores_history" :paso_actual="status_step" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogHistoryRiskVisible = false">{{ $t("Cerrar") }}</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Historial de comentarios" :visible.sync="openDialogComentario" width="30%"
      :before-close="handleClose">
      <div style="height: 400px; overflow: auto">
        <p v-html="comentario"></p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openDialogComentario = false">Cerrar</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Sustituir por estandarizado" :visible.sync="dialogChangeEstandarizado" width="40%"
      :before-close="handleClose">
      <center v-if="loadingChangeRisk">
        <br />
        <br />
        <Circle9 style="margin-bottom: 8px"></Circle9>
        <small>Cargando Datos ...</small>
        <br />
        <br />
      </center>
      <el-table v-else height="400" :data="$store.getters.allRisks" style="width: 100%">
        <el-table-column width="150" label="Acciones">
          <template slot-scope="scope">
            <el-button size="small" @click="changeRiskEstandarizado(scope.row)" type="warning">Seleccionar</el-button>
          </template>
        </el-table-column>
        <el-table-column label="Faena" width="170">
          <template slot-scope="scope">
            {{ faenas[$store.getters.role.faena_id] }}
          </template>
        </el-table-column>
        <el-table-column prop="nombre" label="Nombre del riesgo"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogChangeEstandarizado = false">Cancelar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Circle9 } from "vue-loading-spinner";
import axios from "axios";
import Vue from "vue";
import uuid from "uuid/v4";
import moment from "moment-timezone";
import { Loading } from "element-ui";
import { mapGetters, mapActions } from "vuex";
import { Roles } from "@/utils/generalObjects";
import {
  canReviewRisk,
  canChangeRisk,
  findRootArea,
} from "@/utils/generalFunctions";

import HistoryRisk from "@/components/HistoryRisk.vue";
import InventarioBowtie from "@/components/InventarioBowtie.vue";
import {
  probabilidades,
  nivelSeveridad,
  factorSeveridad,
} from "@/lang/tableInformation.js";

export default {
  components: {
    Circle9,
    InventarioBowtie,
    HistoryRisk,
  },
  props: {
    copyRisks: {
      type: Function,
    },
    updateInventory: {
      type: Function,
    },
    refreshCollapse: {
      type: Function,
    },
    contractPeople: {
      type: Array,
    },
    contract: {
      type: Object,
    },
    workflows: {
      type: Object,
    },
    task: {
      type: Object,
      required: false,
    },
    ids: {
      type: Array,
      required: false,
    },
    risks: {
      type: Array,
      required: true,
    },
    withStatus: {
      type: Boolean,
      // required: true,
      default: false,
    },
    filtro_tipo_riesgo: {
      type: Object,
      default: () => ({
        "Salud y Seguridad": true,
        "salud y seguridad": true,
        salud: true,
        seguridad: true,
        medioambiente: true,
      }),
    },
    filtro_usuario_riesgo: {
      default: false,
    },
  },
  data() {
    return {
      faenas: {
        "5a6f78337b772dcfe68241d5": "Minera Escondida",
        "5a6f78417b772dcfe68241e5": "Minera Spence",
        "5a6f784e7b772dcfe68241f4": "Minera Cerro Colorado",
        "5b48f15d6f0ed90fc02826e3": "BHP",
        "5c262b3176851b775b8bdefc": "Safety Club",
      },
      accidenteEnRutaMel: {},
      loadingChangeRisk: false,
      render: 0,
      dialogChangeEstandarizado: false,
      acciones: [],
      opciones_comentarios: [
        {
          value: "Cambiar nombre a riesgo estandarizado",
          label: "Cambiar nombre a riesgo estandarizado",
        },
        {
          value: "Cambiar, (subir o bajar) nivel de MFL",
          label: "Cambiar, (subir o bajar) nivel de MFL",
        },
        {
          value: "Incluir control mitigador",
          label: "Incluir control mitigador",
        },
        {
          value: "Incluir control preventivo",
          label: "Incluir control preventivo",
        },
        {
          value: "Controles no cubren todas las causas",
          label: "Controles no cubren todas las causas",
        },
        {
          value: "No es causa",
          label: "No es causa",
        },
        {
          value: "No es control",
          label: "No es control",
        },
        {
          value: "No es riesgo",
          label: "No es riesgo",
        },
        {
          value: "Otro",
          label: "Otro",
        },
      ],
      comentario: "",
      openDialogComentario: false,
      roles: {
        super: "Superintendente",
        manager: "Gerente",
        contractor_coordinator: "Coordinador contratista",
        contractor_hse: "HSE Contratista",
        administrator: "Administrador de contratos",
        coordinator: "Coordinador",
        owner: "Dueño de contrato",
        risk: "Especialista de riesgos",
        hse: "HSE",
        health: "Salud",
        safety: "Seguridad",
        environment: "Medioambiente",
      },
      bhpProfiles: {
        hse: "HSE",
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente",
      },
      risk_copy: {},
      fechaUltimaRevision: "",
      ultimoRevisor: "",
      factorSeveridad,
      nivelSeveridad,
      probabilidades,
      Roles,
      nombreRiesgo: "",
      status_step: null,
      revisores_history: [],
      isLoadingPDFTabla: false,
      isLoadingPDFBowtie: false,
      dialogChangeRiskVisible: false,
      dialogVerificarEstado: false,
      dialogHistoryRiskVisible: false,
      actualRisk: {},
      status: {
        status: "",
        status_step: "",
        message: "",
      },
      roleCoordinator: {
        coordinator: true,
        contractor_coordinator: true,
      },
      riskPerChange: null,
      dataHistory: [],
    };
  },
  computed: {
    ...mapGetters({
      actualRole: "actualRole",
      usersFaena: "usersFaena",
    }),
    taskId() {
      return this.task.id;
    },
  },
  async created() {
    await this.getUsersFaena(this.$store.getters.role.faena_id);
    this.$store.dispatch("getAllRisks");
  },
  methods: {
    ...mapActions(["getUsersFaena"]),
    getContentFS(imp, row) {
      var resp = "pendiente";
      if (imp.impacto) {
        var resp = this.factorSeveridad[imp.impacto.factor_severidad] && factorSeveridad[imp.impacto.factor_severidad][this.validarTipoImpacto(row)]
      }
      return resp;
    },
    getContentFP(imp, row) {
      var resp = "pendiente";
      if (imp.impacto) {
        var resp = this.probabilidades[imp.impacto.factor_probabilidad] && probabilidades[imp.impacto.factor_probabilidad]['value']
      }
      return resp;
    },
    validRevision(riesgo, accion) {
      if (this.ids) {
        var pos = this.ids
          .map(function (e) {
            return e.riesgo._id;
          })
          .indexOf(riesgo._id);
        if (pos > -1) {
          if (this.ids[pos]["accion"] === accion) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    revisar(riesgo, accion) {
      if (this.ids.filter((e) => e.riesgo._id === riesgo._id).length > 0) {
        var pos = this.ids
          .map(function (e) {
            return e.riesgo._id;
          })
          .indexOf(riesgo._id);
        if (pos > -1) {
          if (this.ids[pos]["accion"] === accion) {
            this.ids.splice(pos, 1);
            if (
              this.$store.getters.role.faena_id !== "5a6f78337b772dcfe68241d5"
            ) {
              this.ids.push({
                task: this.task.nombre,
                task_id: this.task.id || this.task._id,
                accion: "aprobar",
                riesgo: riesgo,
                observaciones: [],
                comentario: "",
              });
            }
          } else {
            this.ids.splice(pos, 1);
            this.ids.push({
              task: this.task.nombre,
              task_id: this.task.id || this.task._id,
              accion: accion,
              riesgo: riesgo,
              observaciones: [],
              comentario: "",
            });
          }
        }
      } else {
        this.ids.push({
          task: this.task.nombre,
          task_id: this.task.id || this.task._id,
          accion: accion,
          riesgo: riesgo,
          observaciones: [],
          comentario: "",
        });
      }
    },
    changeRiskEstandarizado(estandarizado) {
      this.$confirm(
        `Estas a punto de sustituir el riesgo "${this.riskPerChange.nombre}" por el riesgo estandarizado "${estandarizado.nombre}", ¿Deseas continuar?`,
        "Advertencia",
        {
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(async () => {
        const self = this;
        this.loadingChangeRisk = true;

        const pending = [];

        await this.$store.getters.inventario.tareas.forEach((t) => {
          if (t.id === this.task.id || t._id === this.task._id) {
            const pos = t.riesgos
              .map((e) => e._id)
              .indexOf(this.riskPerChange._id);
            if (pos !== -1) {
              t.riesgos[pos] = estandarizado;
            }
          }
        });

        await this.$store.getters.inventario.tareas.forEach((t) => {
          if (t.riesgos) {
            t.riesgos.forEach((r) => {
              if (r.custom === true) {
                if (r.status === 0) {
                  pending.push(r.nombre);
                }
              }
            });
          }
        });

        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
        axios
          .post(
            "/inventarios/updateInventory",
            {
              id_inventory: this.$store.getters.inventario._id,
              tareas: this.$store.getters.inventario.tareas,
              isTherePendings: pending.length !== 0,
            },
            config
          )
          .then((response) => {
            axios
              .post(
                "/inventarios/uptadeHistoryInventory",
                {
                  id_inventory: self.$store.getters.inventario._id,
                  action: `Riesgo ${self.riskPerChange.nombre} ha sido sustituido por el riesgo estandarizado ${estandarizado.nombre}.`,
                  user: self.username(),
                  date: new Date(),
                  type: "update",
                },
                config
              )
              .then((response) => { });
            self.$notify({
              title: "Información",
              message: "Riesgo sustituido exitosamente.",
              type: "success",
            });
            self.updateInventory(self.$store.getters.inventario);
            self.render++;
            self.dialogChangeEstandarizado = false;
            if (pending.length === 0) {
              const url = `/inventario/${self.contract._id}/ver`;
              self.$router.push({
                path: url,
              });
              self.$store.dispatch("getUserContractByRole", {
                user: self.$store.getters.user,
                role: self.$store.getters.role,
              });
            }
            self.loadingChangeRisk = false;
          });
      });
    },
    openChangeEstandarizado(risk) {
      this.riskPerChange = JSON.parse(JSON.stringify(risk));
      this.dialogChangeEstandarizado = true;
    },
    verComentarios(comentario) {
      this.openDialogComentario = true;
      this.comentario = comentario;
    },
    validarTipoImpacto(risk) {
      if (
        this.getMayorImpacto(risk).impacto.categoria.toLowerCase() ===
        "salud y seguridad"
      ) {
        return "seguridad";
      }
      return this.getMayorImpacto(risk).impacto.categoria.toLowerCase();
    },
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
    handleClose() {
      this.dialogChangeEstandarizado = false;
      this.dialogHistoryRiskVisible = false;
      this.openDialogComentario = false;
    },
    pintar({ row, column, rowIndex, columnIndex }) {
      let classes = "cellClassTablaPloma ";
      if (columnIndex === 0) {
        if (row.custom === true) {
          classes += "colorCustom";
        } else if (row.impactos && row.impactos.length > 0 && row.impactos[0].categoria === "Seguridad" && !row.custom) {
          classes += "colorSeguridad";
        } else if (row.impactos && row.impactos.length > 0 && row.impactos[0].categoria === "Salud" && !row.custom) {
          classes += "colorSalud";
        } else if (
          row.impactos && row.impactos.length > 0 && row.impactos[0].categoria === "Salud y Seguridad" &&
          !row.custom
        ) {
          classes += "colorSaludySeguridad";
        } else if (
          row.impactos && row.impactos.length > 0 && row.impactos[0].categoria === "Medioambiente" &&
          !row.custom
        ) {
          classes += "colorMedioambiente";
        }
      }
      return classes;
    },
    isActiveContract(contract) {
      if (contract.tipo_contrato == "Propio") return true;
      return moment(contract.fecha_fin) - new Date() >= 0;
    },
    ShowDialogHistoryRisk(risk) {
      this.nombreRiesgo = risk.nombre;
      let revisor = {};
      this.revisores_history = [];
      const impacto = this.getMayorImpacto(risk);
      const workflow = this.workflows[risk.tipo.toLowerCase()];
      const steps = workflow.risks[impacto.mfl - 1];
      this.status_step = risk.status_step;
      steps.forEach((step, i) => {
        revisor.paso = i;
        revisor.revisores = [];
        revisor.personas = [];
        for (let index = 0; index < step.peopleProfile.length; index++) {
          revisor.revisores.push(this.getPerfil(step.peopleProfile[index]));
          if (this.contract.revisores[step.peopleProfile[index]]) {
            for (
              let x = 0;
              x < this.contract.revisores[step.peopleProfile[index]].length;
              x++
            ) {
              const pos = this.usersFaena
                .map((e) => e._id)
                .indexOf(this.contract.revisores[step.peopleProfile[index]][x]);
              if (pos !== -1) {
                const evaluador = this.usersFaena[pos];
                revisor.personas.push(
                  `${evaluador.nombre} ${evaluador.apellido}`
                );
              }
            }
          } else {
            switch (step.peopleProfile[index]) {
              case "manager":
                revisor.personas.push(
                  `${this.contract.area.gerente.nombre} ${this.contract.area.gerente.apellido}`
                );
                break;
              case "general_manager":
                console.error("No viene en el object del área");
                break;
              case "super":
                revisor.personas.push(
                  `${this.contract.area[step.peopleProfile[index]].nombre} ${this.contract.area[step.peopleProfile[index]].apellido
                  }`
                );
                revisor.personas.push(
                  `${this.contract.area["super_dos"].nombre} ${this.contract.area["super_dos"].apellido
                  }`
                );
                break;
              default:
                break;
            }
          }
        }
        this.revisores_history.push(revisor);
        revisor = {};
      });
      this.dialogHistoryRiskVisible = true;
    }, // ShowDialogHistoryRisk

    getPerfil(profile) {
      return this.Roles[profile] || "";
    },
    nextReviewer(risk) {
      try {
        const impacto = this.getMayorImpacto(risk);
        const workflow = this.workflows[risk.tipo.toLowerCase()];
        if (!workflow) {
          console.error(
            `no se encontro wf con el riesgo con el tipo ${risk.tipo}`,
            risk
          );
        } // if
        const steps = workflow.risks[impacto.mfl - 1];
        const statusStep = parseInt(risk.status_step);
        if (!workflow) return false;
        if (
          statusStep === -1 ||
          statusStep === "-1" ||
          statusStep === undefined
        ) {
          if (this.contract.tipo_contrato === "Contratista") {
            const revisores = [];
            revisores.push(this.getPerfil("contractor_coordinator"));
            this.contract.revisores.contractor_coordinator.forEach((r) => {
              const user = this.contractPeople.find((x) => x._id === r);
              revisores.push(`${user.nombre} ${user.apellido}`);
            });
            return revisores.join("<br>");
          }
          const revisores = [];
          revisores.push(this.getPerfil("coordinator"));
          this.contract.revisores.coordinator.forEach((r) => {
            const user = this.contractPeople.find((x) => x._id === r);
            revisores.push(`${user.nombre} ${user.apellido}`);
          });
          return revisores.join("<br>");
        }
        if (statusStep === steps.length) {
          return "";
        }
        const newStep = steps[statusStep];
        const reviewers = [];
        if (newStep) {
          newStep.peopleProfile.forEach((profile) => {
            reviewers.push(this.getPerfil(profile));
            if (profile === "super") {
              reviewers.push(
                `${this.contract.area.super.nombre} ${this.contract.area.super.apellido}`
              );
              reviewers.push(
                `${this.contract.area.super_dos.nombre} ${this.contract.area.super_dos.apellido}`
              );
            }
            if (profile === "manager") {
              reviewers.push(
                `${this.contract.area.gerente.nombre} ${this.contract.area.gerente.apellido}`
              );
            }
            if (profile !== "super" && profile !== "manager") {
              this.contract.revisores[profile].forEach((r) => {
                const { nombre } = this.contractPeople.find((x) => x._id === r) || { nombre: "Usuario" };
                const { apellido } = this.contractPeople.find(
                  (x) => x._id === r
                ) || { apellido: "no encontrado" };
                reviewers.push(`${nombre} ${apellido}`);
              });
            }
          });
          // si todos son necesarios ', ' (and) sino ' | ' (or)
          return newStep.minToApprove > 1
            ? `<br> <i class="el-icon-info" ></i> <b>Se requiere la revisión de ${newStep.minToApprove
            } de los siguientes usuarios.</b><br><i class="el-icon-d-arrow-right"></i> ${reviewers.join(
              " <br> "
            )}`
            : `<br> <i class="el-icon-info" ></i> <b>Se requiere la revisión de uno de los siguientes usuarios.</b><br><i class="el-icon-d-arrow-right"></i> ${reviewers.join(
              " <br> "
            )}`; // solamente estético
        }
      } catch (e) {
        console.log(e);
        return "";
      }
    }, // nextReviewer
    canChangeRisk(risk) {
      return (parseInt(risk.status_step) === -1 &&
        (this.actualRole === "coordinator" ||
          this.actualRole === "contractor_coordinator")) ||
        this.$store.getters.role.admin
        ? true
        : canChangeRisk({ risk, profile: this.actualRole });
    },
    reviewedRisk(risk) {
      try {
        if (!risk.custom) return false;
        if (risk.status_step === -1) return false;
        let i = parseInt(risk.status_step);
        if (i <= 0) return false;
        //
        let reviewed = false;
        const obj = {
          user: this.$store.getters.user,
          risk,
          contract: this.contract,
          actualProfile: this.actualRole,
          workflows: this.workflows,
        };

        for (i; i >= 0; i--) {
          obj.risk = { ...risk };
          obj.risk.status_step = i;
          reviewed = canReviewRisk(obj);
          if (reviewed) break;
        } // for
        return reviewed;
      } catch (e) {
        console.error(e);
        return false;
      } // try
    }, // reviewedRisk
    canReviewRisk(risk) {
      if (!risk.custom) return false;
      if (risk.status_step === -1) return false;
      if (this.$store.getters.role.admin && risk.status !== 1) return true;
      const obj = {
        user: this.$store.getters.user,
        risk,
        contract: this.contract,
        actualProfile: this.actualRole,
        workflows: this.workflows,
      };
      const ret = canReviewRisk(obj); // if
      /* if (this.actualRole === 'administrator' && ret === false) {
        obj.actualProfile = 'admin';
        ret = canReviewRisk(obj);
      } */ return ret;
    },
    async deleteRisk(risk) {
      this.$confirm(
        `Estas a punto de eliminar el riesgo "${risk.nombre}", ¿Deseas continuar?`,
        "Advertencia",
        {
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(async () => {
        const pending = [];
        const self = this;
        await this.$store.getters.inventario.tareas.forEach((t, index) => {
          if (t.id === this.task.id) {
            if (t.riesgos) {
              t.riesgos.forEach((r, i) => {
                if (risk._id === r._id) {
                  t.riesgos.splice(i, 1);
                }
              });
            }
          }
          if (t.riesgos.length === 0) {
            this.$store.getters.inventario.tareas.splice(index, 1);
          }
        });
        await this.$store.getters.inventario.tareas.forEach((t) => {
          if (t.riesgos) {
            t.riesgos.forEach((r) => {
              if (r.custom === true) {
                if (r.status === 0) {
                  pending.push(r.nombre);
                }
              }
            });
          }
        });
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
        axios
          .post(
            "/inventarios/updateInventory",
            {
              id_inventory: this.$store.getters.inventario._id,
              tareas: this.$store.getters.inventario.tareas,
              isTherePendings: pending.length !== 0,
            },
            config
          )
          .then((response) => {
            axios
              .post(
                "/inventarios/uptadeHistoryInventory",
                {
                  id_inventory: self.$store.getters.inventario._id,
                  action: `Riesgo ${risk.nombre} ha sido eliminado.`,
                  user: self.username(),
                  date: new Date(),
                  type: "delete",
                },
                config
              )
              .then((response) => { });
            self.$notify({
              title: "Información",
              message: "Riesgo eliminado exitosamente.",
              type: "success",
            });
            if (pending.length === 0) {
              const url = `/inventario/${self.contract._id}/ver`;
              self.$router.push({
                path: url,
              });
              self.$store.dispatch("getUserContractByRole", {
                user: self.$store.getters.user,
                role: self.$store.getters.role,
              });
            }
          });
      });
    },
    changeRisk(riesgo) {
      // Copia objeto para poder modificarlo
      this.actualRisk = JSON.parse(JSON.stringify(riesgo));
      this.risk_copy = JSON.parse(JSON.stringify(riesgo));
      if (!this.actualRisk.medioambiente) {
        this.actualRisk.medioambiente = {};
      }
      this.dialogChangeRiskVisible = true;
    },
    closeChangeRisk() {
      this.$confirm(
        this.$t(
          "Se perderán todos los cambios que haya realizado. ¿Está seguro de cancelar?"
        ),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        this.dialogChangeRiskVisible = false;
        this.dataHistory = [];
      });
    },
    saveRisk() {
      if (this.actualRisk.nombre !== this.risk_copy.nombre) {
        this.dataHistory.push({
          id_inventory: this.$store.getters.inventario._id,
          action: `Se modificó el nombre del riesgo ${this.risk_copy.nombre} se actualizó ha ${this.actualRisk.nombre}.`,
          user: this.username(),
          date: new Date(),
          type: "update",
        });
      }
      if (
        this.actualRisk.escenario_residual !== this.risk_copy.escenario_residual
      ) {
        this.dataHistory.push({
          id_inventory: this.$store.getters.inventario._id,
          action: `Se modificó el escenario residual "${this.risk_copy.escenario_residual}" se actualizó ha "${this.actualRisk.escenario_residual}".`,
          user: this.username(),
          date: new Date(),
          type: "update",
        });
      }
      if (this.actualRisk.escenario_mfl !== this.risk_copy.escenario_mfl) {
        this.dataHistory.push({
          id_inventory: this.$store.getters.inventario._id,
          action: `Se modificó el escenario mfl "${this.risk_copy.escenario_mfl}" se actualizó ha "${this.actualRisk.escenario_mfl}".`,
          user: this.username(),
          date: new Date(),
          type: "update",
        });
      }

      if (!this.actualRisk.impactos || this.actualRisk.impactos.length === 0) {
        this.$notify({
          title: "Información",
          message: "Para continuar debe ingresar un impacto asociado.",
          type: "warning",
        });
        return false;
      }

      if ((this.actualRisk.impactos && this.actualRisk.impactos.length > 0) && (!this.actualRisk.impactos[0]["controles_mitigadores"] || this.actualRisk.impactos[0]["controles_mitigadores"].length === 0)) {
        this.$notify({
          title: "Información",
          message: "Para continuar debe ingresar al menos un control mitigador.",
          type: "warning",
        });
        return false;
      }

      if (JSON.stringify(this.actualRisk) === JSON.stringify(this.risk_copy)) {
        this.$confirm(
          this.$t(
            "No has realizado ningún cambio en el riesgo, estás seguro que deseas continuar?"
          ),
          this.$t("Atención"),
          { type: "warning" }
        ).then(() => {
          if (
            ["health", "safety", "environment"].includes(
              this.$store.getters.role.role
            )
          ) {
            this.updateRiskFast();
          }
          if (
            ["coordinator", "contractor_coordinator"].includes(
              this.$store.getters.role.role
            ) ||
            this.$store.getters.role.admin
          ) {
            this.updateRisk();
          }
        });
      } else {
        if (
          ["health", "safety", "environment"].includes(
            this.$store.getters.role.role
          )
        ) {
          this.updateRiskFast();
        }
        if (
          ["coordinator", "contractor_coordinator"].includes(
            this.$store.getters.role.role
          ) ||
          this.$store.getters.role.admin
        ) {
          this.updateRisk();
        }
      }
    },
    updateRiskFast() {
      this.$confirm(
        this.$t(
          "Estos cambios serán sujetos a revisión. ¿Está seguro de continuar?"
        ),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };

        var json = {
          rol_update: this.$store.getters.role.admin ? "Administrador de plataforma" : this.bhpProfiles[this.$store.getters.role.role],
          nombre_update: `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`,
          inv_id: this.$store.getters.inventario._id,
          task_id: this.task.id || this.task._id,
          risk_id: this.actualRisk._id,
          riesgo: this.actualRisk,
        };
        axios
          .post("/inventarios/edit-risk-fast", json, config)
          .then((response) => {
            if (response.data.success === true) {
              const loadingInstance = Loading.service({ fullscreen: true });
              const statusHistoryVal = {};
              statusHistoryVal.nombre = this.$store.getters.user.nombre;
              statusHistoryVal.nombre += ` ${this.$store.getters.user.apellido}`;
              statusHistoryVal.fecha = this.$moment().format("LLLL");

              // Cambia status segun mfl y estado actual del paso
              let { status } = this.actualRisk;
              let statusStep = this.actualRisk.status_step;
              const { mfl } = this.getMayorImpacto(this.actualRisk);

              const workflow =
                this.workflows[this.actualRisk.tipo.toLowerCase()];
              // mfl = riesgo de mayor nivel
              const steps = workflow.risks[mfl - 1];
              const lastStep = steps.length;
              const actualStep = steps[statusStep];
              let statusStepApprovedByProfiles = this.actualRisk
                .status_step_approved_by_profiles
                ? this.actualRisk.status_step_approved_by_profiles
                : [];
              let statusHistory = this.actualRisk.status_history
                ? this.actualRisk.status_history
                : [[]];

              // Revision normal

              if (this.$store.getters.role.admin) {
                statusHistoryVal.perfil = "superadmin";
                statusStepApprovedByProfiles.push("superadmin");
                statusHistory[statusHistory.length - 1].push(statusHistoryVal);
                // reset cuando step está listo
                if (
                  statusStepApprovedByProfiles.length >=
                  parseInt(actualStep.minToApprove)
                ) {
                  statusStep += 1;
                  statusStepApprovedByProfiles = [];
                  statusHistory.push([]);
                }
              } else {
                const profile = this.$store.getters.role.role;
                /* if (profile === 'administrator') profile = 'admin'; */
                statusStepApprovedByProfiles.push(profile);
                statusHistoryVal.perfil = profile;
                statusHistory[statusHistory.length - 1].push(statusHistoryVal);
                if (
                  statusStepApprovedByProfiles.length >=
                  parseInt(actualStep.minToApprove)
                ) {
                  statusStep += 1;
                  statusStepApprovedByProfiles = [];
                  statusHistory.push([]);
                }
              }
              if (statusStep === lastStep) {
                status = 1;
              }

              const risk_id = this.actualRisk._id;
              let msj = "";
              this.acciones.push(`Modifica y Aprueba Riesgo`);
              let acciones = "";
              this.acciones.forEach((a) => {
                acciones += `<li>${a}</li>`;
              });
              msj =
                `<b>Nombre:</b> ${this.username()} <br> <b>Rol</b>: ${this.$store.getters.role.admin === true
                  ? "Administrador de Plataforma"
                  : this.roles[this.$store.getters.role.role]
                } <br> <b>Observaciones: </b> <br> ${acciones} <b>Fecha:</b> ${new Date().toLocaleString()} ${this.actualRisk.status_message &&
                  this.actualRisk.status_message.length > 0
                  ? "<hr style='margin-top: 15px; margin-bottom: 15px;'>"
                  : ""
                } ` +
                `${this.actualRisk.status_message &&
                  this.actualRisk.status_message.length > 0
                  ? this.actualRisk.status_message
                  : ""
                }`;
              const statusBy = `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
              const statusPosition = this.$store.getters.role.admin
                ? "superadmin"
                : this.$store.getters.role.role;
              // aqui se envia
              this.$store
                .dispatch("updateRiskStatus", {
                  id: this.$store.getters.inventario._id,
                  task_id: this.task.id || this.task._id,
                  risk_id,
                  status,
                  status_step: statusStep,
                  status_by: statusBy,
                  status_position: statusPosition,
                  status_message: msj,
                  status_step_approved_by_profiles:
                    statusStepApprovedByProfiles,
                  status_history: statusHistory,
                })
                .then((response) => {
                  if (response.status) {
                    this.dataHistory.forEach((dh) => {
                      const config = {
                        headers: {
                          Authorization: `Bearer ${localStorage.getItem(
                            "token"
                          )}`,
                        },
                      };
                      axios
                        .post("/inventarios/uptadeHistoryInventory", dh, config)
                        .then((response) => { });
                    });
                    // cuando salio todo bien
                    // actualiza los datos del riesgo con los datos locales
                    // para evitar ir a buscar todo el inventario como lo hacia
                    // antes cada vez que se editaba un riesgo
                    const risk = this.risks.find((r) => r._id == risk_id);
                    this.$store.dispatch("InventoryEditRisk", {
                      risk,
                      obj: {
                        status,
                        status_step: statusStep,
                        status_by: statusBy,
                        status_position: statusPosition,
                        status_message: msj,
                        status_step_approved_by_profiles:
                          statusStepApprovedByProfiles,
                        status_history: statusHistory,
                      },
                    });

                    // busca si hay almenos 1 riesgo sin aprobar
                    const resp = this.$store.getters.inventario.tareas.some(
                      (t) =>
                        t.riesgos &&
                        t.riesgos.some((r) => r.custom == true && r.status != 1)
                    );
                    // si no hay entonces el inventario se aprobo
                    // si se aprobo hay que setear la var de contrato que se muestra en select a aprobado
                    if (resp === false) {
                      this.$store.commit("EDIT_INVENTORY", {
                        status: 2,
                        wasApproved: true,
                      });

                      const inventoryId = this.$store.getters.inventario._id;
                      this.$store.dispatch("userContractAssignInventory", {
                        inventoryId,
                        obj: { status: 2 },
                      });
                      this.$store
                        .dispatch(
                          "setDateInventoryApproved",
                          this.$store.getters.inventario
                        )
                        .then(async (response) => {
                          if (response.status === true) {
                          } else {
                            console.log(
                              "La fecha de aprobación no ha podido actualizarse"
                            );
                          }
                        });
                      this.$store.dispatch("setStatus", 2);
                    } // if

                    this.refreshCollapse();
                    this.dataHistory = [];
                    this.dialogChangeRiskVisible = false;
                    this.$store.dispatch("getInventory", this.contract);

                    this.$alert(response.message, this.$t("Atención"), {
                      type: "success",
                    });
                  } else {
                    this.dataHistory = [];
                    this.$alert(
                      this.$t(
                        "Lo sentimos, surgió un error al actualizar estado. Intente nuevamente."
                      ),
                      this.$t("Atención"),
                      {
                        type: "error",
                      }
                    );
                  } // if
                  loadingInstance.close();
                });
              this.closeDialogVerificarEstado();
            }
          });
      });
    },
    updateRisk() {
      this.$confirm(
        this.$t(
          "Estos cambios serán sujetos a revisión. ¿Está seguro de continuar?"
        ),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        this.actualRisk.status = 0;
        this.actualRisk.status_step = 0;
        this.actualRisk.status_by = this.username();
        this.actualRisk.status_position = this.$store.getters.role.role;

        const loadingInstance = Loading.service({ fullscreen: true });
        this.actualRisk.status_history = [[]];
        this.$store
          .dispatch("updateRiskReviewed", {
            inventory_id: this.$store.getters.inventario._id,
            task_id: this.task.id || this.task._id,
            risk: this.actualRisk,
            username: this.username(),
            admin: this.$store.getters.role.admin,
            role: this.roles[this.$store.getters.role.role]
          })
          .then((response) => {
            if (response.status === true) {
              this.dataHistory.forEach((dh) => {
                const config = {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                  },
                };
                axios
                  .post("/inventarios/uptadeHistoryInventory", dh, config)
                  .then((response) => { });
              });
              this.$store.dispatch("getInventory", this.contract);
              this.$alert(
                this.$t(
                  "Riesgo actualizado y enviado a aprobación exitosamente."
                ),
                this.$t("Atención"),
                {
                  type: "success",
                }
              );
              this.refreshCollapse();
              this.dataHistory = [];
              this.dialogChangeRiskVisible = false;
            } else {
              this.$alert(
                this.$t(
                  "Lo sentimos, surgió un error al actualizar el riesgo. Intente nuevamente."
                ),
                this.$t("Atención"),
                {
                  type: "error",
                }
              );
              this.dataHistory = [];
            }
            loadingInstance.close();
          });
      });
    },
    saveVerificarEstado() {
      this.$confirm(
        this.$t(
          "¿Está seguro de esta revisión? Un email de aviso será enviado"
        ),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        const loadingInstance = Loading.service({ fullscreen: true });
        const statusHistoryVal = {};
        statusHistoryVal.nombre = this.$store.getters.user.nombre;
        statusHistoryVal.nombre += ` ${this.$store.getters.user.apellido}`;
        statusHistoryVal.fecha = this.$moment().format("LLLL");

        // Cambia status segun mfl y estado actual del paso
        let { status } = this.actualRisk;
        let statusStep = this.actualRisk.status_step;
        const { mfl } = this.getMayorImpacto(this.actualRisk);

        const workflow = this.workflows[this.actualRisk.tipo.toLowerCase()];
        // mfl = riesgo de mayor nivel
        const steps = workflow.risks[mfl - 1];
        const lastStep = steps.length;
        const actualStep = steps[statusStep];
        let statusStepApprovedByProfiles = this.actualRisk
          .status_step_approved_by_profiles
          ? this.actualRisk.status_step_approved_by_profiles
          : [];
        let statusHistory = this.actualRisk.status_history
          ? this.actualRisk.status_history
          : [[]];
        // Revision normal
        if (this.status.status_step === "true") {
          if (this.$store.getters.role.admin) {
            statusHistoryVal.perfil = "superadmin";
            statusStepApprovedByProfiles.push("superadmin");
            statusHistory[statusHistory.length - 1].push(statusHistoryVal);
            // reset cuando step está listo
            if (
              statusStepApprovedByProfiles.length >=
              parseInt(actualStep.minToApprove)
            ) {
              statusStep += 1;
              statusStepApprovedByProfiles = [];
              statusHistory.push([]);
            }
          } else {
            const profile = this.$store.getters.role.role;
            /* if (profile === 'administrator') profile = 'admin'; */
            statusStepApprovedByProfiles.push(profile);
            statusHistoryVal.perfil = profile;
            statusHistory[statusHistory.length - 1].push(statusHistoryVal);
            if (
              statusStepApprovedByProfiles.length >=
              parseInt(actualStep.minToApprove)
            ) {
              statusStep += 1;
              statusStepApprovedByProfiles = [];
              statusHistory.push([]);
            }
          }
          if (statusStep === lastStep) {
            status = 1;
          }
        } else {
          statusStep = -1;
          // como se rechazo el 'historial' tambien
          statusHistory = [[]];
        } // if
        const risk_id = this.actualRisk._id;
        let msj = "";
        if (this.status.message !== "") {
          let acciones = "";
          this.acciones.forEach((a) => {
            acciones += `<li>${a}</li>`;
          });
          msj =
            `<b>Nombre:</b> ${this.username()} <br> <b>Rol</b>: ${this.$store.getters.role.admin === true
              ? "Administrador de Plataforma"
              : this.roles[this.$store.getters.role.role]
            } <br> <b>Observaciones: </b> <br> ${acciones} <b>Fecha:</b> ${new Date().toLocaleString()} <br> <b>Observaciones adicionales:</b> <br> ${this.status.message
            } ${this.actualRisk.status_message &&
              this.actualRisk.status_message.length > 0
              ? "<hr style='margin-top: 15px; margin-bottom: 15px;'>"
              : ""
            } ` +
            `${this.actualRisk.status_message &&
              this.actualRisk.status_message.length > 0
              ? this.actualRisk.status_message
              : ""
            }`;
        } else {
          msj = this.actualRisk.status_message;
        }
        const statusBy = `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
        const statusPosition = this.$store.getters.role.admin
          ? "superadmin"
          : this.$store.getters.role.role;
        // aqui se envia
        this.$store
          .dispatch("updateRiskStatus", {
            id: this.$store.getters.inventario._id,
            task_id: this.task.id || this.task._id,
            risk_id,
            status,
            status_step: statusStep,
            status_by: statusBy,
            status_position: statusPosition,
            status_message: msj,
            status_step_approved_by_profiles: statusStepApprovedByProfiles,
            status_history: statusHistory,
          })
          .then((response) => {
            if (response.status) {
              // cuando salio todo bien
              // actualiza los datos del riesgo con los datos locales
              // para evitar ir a buscar todo el inventario como lo hacia
              // antes cada vez que se editaba un riesgo
              const risk = this.risks.find((r) => r._id == risk_id);
              this.$store.dispatch("InventoryEditRisk", {
                risk,
                obj: {
                  status,
                  status_step: statusStep,
                  status_by: statusBy,
                  status_position: statusPosition,
                  status_message: msj,
                  status_step_approved_by_profiles:
                    statusStepApprovedByProfiles,
                  status_history: statusHistory,
                },
              });

              // busca si hay almenos 1 riesgo sin aprobar
              const resp = this.$store.getters.inventario.tareas.some(
                (t) =>
                  t.riesgos &&
                  t.riesgos.some((r) => r.custom == true && r.status != 1)
              );
              // si no hay entonces el inventario se aprobo
              // si se aprobo hay que setear la var de contrato que se muestra en select a aprobado
              if (resp === false) {
                this.$store.commit("EDIT_INVENTORY", {
                  status: 2,
                  wasApproved: true,
                });

                const inventoryId = this.$store.getters.inventario._id;
                this.$store.dispatch("userContractAssignInventory", {
                  inventoryId,
                  obj: { status: 2 },
                });
                this.$store
                  .dispatch(
                    "setDateInventoryApproved",
                    this.$store.getters.inventario
                  )
                  .then(async (response) => {
                    if (response.status === true) {
                    } else {
                      console.log(
                        "La fecha de aprobación no ha podido actualizarse"
                      );
                    }
                  });
                this.$store.dispatch("setStatus", 2);
              } // if

              this.$alert(response.message, this.$t("Atención"), {
                type: "success",
              });
            } else {
              this.$alert(
                this.$t(
                  "Lo sentimos, surgió un error al actualizar estado. Intente nuevamente."
                ),
                this.$t("Atención"),
                {
                  type: "error",
                }
              );
            } // if
            loadingInstance.close();
          });
        this.closeDialogVerificarEstado();
      });
    },
    closeDialogVerificarEstado() {
      this.status.status_step = "";
      this.status.message = "";
      this.actualRisk = "";
      this.dialogVerificarEstado = false;
    },
    openDialogVerificarEstado(riesgo, id) {
      this.actualRisk = riesgo;
      this.dialogVerificarEstado = true;
    },
    getControlesPreventivos(risk) {
      const controles = [];
      const controlesId = {};

      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const id = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach((control) => {
              if (!controlesId[control.nombre]) {
                controlesId[control.nombre] = true;
                control.id_causa = id;
                controles.push(control);
              }
            });
          }
        });
      }

      return controles;
    },
    getControlesMitigadores(risk) {
      const controles = [];

      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;

          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach((control) => {
              control.id_impacto = id;
              controles.push(control);
            });
          }
        });
      }

      return controles;
    },
    getMayorImpacto(risk) {
      let mfl = 0;
      let rrr;
      let mayorImpacto;

      if (risk.impactos) {
        risk.impactos.forEach((impacto) => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr =
              (impacto.factor_severidad *
                10 *
                (impacto.factor_probabilidad * 10)) /
              (10 * 10);
            mayorImpacto = impacto;
          }
        });
      }

      return {
        impacto: mayorImpacto,
        mfl,
        rrr,
      };
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return "danger";
      }
      if (mfl === 3) {
        return "warning";
      }
      return "gray";
    },
    sortMFL(a, b) {
      return this.getMayorImpacto(a).mfl >= this.getMayorImpacto(b).mfl;
    },
    tablaStatusClass(row) {
      try {
        let ret = "";
        if (this.withStatus) {
          ret = "";
        } else {
          const { mfl } = this.getMayorImpacto(row);
          if (mfl >= 4) {
            ret = "row-danger";
          } else if (mfl === 3) {
            ret = "row-warning";
          }
        } // if
        if (!row.row.tipo) console.error("no tipo de riesgo");

        if (
          (row.row.tipo &&
            this.filtro_tipo_riesgo[row.row.tipo.toLowerCase()] === false) ||
          (this.filtro_usuario_riesgo &&
            ((!this.roleCoordinator[this.actualRole] &&
              !this.canReviewRisk(row.row)) ||
              (this.roleCoordinator[this.actualRole] &&
                !this.canChangeRisk(row.row))))
        ) {
          ret += " displayNone";
        }

        return `${ret} rowClassTablaPlomaInventarioTarea`;
      } catch (e) {
        console(e);
        return "rowClassTablaPlomaInventarioTarea";
      }
    },
    addCause(causa) {
      const cause = {
        id: uuid(),
        nombre: causa,
      };
      this.actualRisk.causas.push(cause);
      this.dataHistory.push({
        id_inventory: this.$store.getters.inventario._id,
        action: `Se agregó la causa ${cause.nombre} al riesgo ${this.actualRisk.nombre}.`,
        user: this.username(),
        date: new Date(),
        type: "add",
      });
    },
    deleteCause(causaId) {
      const causeIndex = this.actualRisk.causas.findIndex(
        (cause) => cause.id === causaId
      );
      this.dataHistory.push({
        id_inventory: this.$store.getters.inventario._id,
        action: `Se eliminó la causa ${this.actualRisk.causas[causeIndex].nombre} del riesgo ${this.actualRisk.nombre}.`,
        user: this.username(),
        date: new Date(),
        type: "delete",
      });
      Vue.delete(this.actualRisk.causas, causeIndex);
    },
    editCause(causa, causaID) {
      const causeIndex = this.actualRisk.causas.findIndex(
        (cause) => cause.id === causaID
      );
      const oldVal = JSON.parse(
        JSON.stringify(this.actualRisk.causas[causeIndex])
      );
      Vue.set(this.actualRisk.causas, causeIndex, {
        ...this.actualRisk.causas[causeIndex],
        nombre: causa,
      });
      this.dataHistory.push({
        id_inventory: this.$store.getters.inventario._id,
        action: `Se modificó una causa del riesgo, ${oldVal.nombre} se actualizó ha ${causa}.`,
        user: this.username(),
        date: new Date(),
        type: "update",
      });
    },
    addImpact(impacto) {
      const impact = {
        id: uuid(),
        ...impacto,
      };
      this.actualRisk.impactos.push(impact);
      this.dataHistory.push({
        id_inventory: this.$store.getters.inventario._id,
        action: `Se agregó el impacto asociado a la categoría ${impacto.categoria} en el riesgo ${this.actualRisk.nombre}.`,
        user: this.username(),
        date: new Date(),
        type: "add",
      });
    },
    deleteImpact(impactoId) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        (impact) => impact.id === impactoId
      );
      this.dataHistory.push({
        id_inventory: this.$store.getters.inventario._id,
        action: `Se eliminó el impacto asociado a la categoría ${this.actualRisk.impactos[impactIndex].categoria} del riesgo ${this.actualRisk.nombre}.`,
        user: this.username(),
        date: new Date(),
        type: "delete",
      });
      Vue.delete(this.actualRisk.impactos, impactIndex);
    },
    editImpact(impacto, impactoId) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        (impact) => impact.id === impactoId
      );
      Vue.set(this.actualRisk.impactos, impactIndex, {
        ...this.actualRisk.impactos[impactIndex],
        categoria: impacto.categoria,
        descripcion: impacto.descripcion,
        factor_severidad: impacto.factor_severidad,
        factor_probabilidad: impacto.factor_probabilidad,
        nivel_severidad: impacto.nivel_severidad,
        mfl: impacto.mfl,
      });
      this.dataHistory.push({
        id_inventory: this.$store.getters.inventario._id,
        action: `Se modificó el impacto del riesgo, ( Categoría: ${impacto.categoria}, Factor de severidad: ${impacto.factor_severidad}, Factor de probabilidad: ${impacto.factor_probabilidad}, MFL: ${impacto.mfl} ).`,
        user: this.username(),
        date: new Date(),
        type: "update",
      });
    },
    addPreventiveControl(causasId, control) {
      causasId.forEach((causaId) => {
        const causeIndex = this.actualRisk.causas.findIndex(
          (cause) => cause.id === causaId
        );
        if (!this.actualRisk.causas[causeIndex].controles_preventivos) {
          Vue.set(this.actualRisk.causas, causeIndex, {
            ...this.actualRisk.causas[causeIndex],
            controles_preventivos: [],
          });
        }
        const controlPreventivo = {
          id: uuid(),
          nombre: control,
        };
        this.actualRisk.causas[causeIndex].controles_preventivos.push(
          controlPreventivo
        );
      });
    },
    deletePreventiveControl(causaId, controlId) {
      const causeIndex = this.actualRisk.causas.findIndex(
        (cause) => cause.id === causaId
      );
      const controlIndex = this.actualRisk.causas[
        causeIndex
      ].controles_preventivos.findIndex((control) => control.id === controlId);
      Vue.delete(
        this.actualRisk.causas[causeIndex].controles_preventivos,
        controlIndex
      );
    },
    editPreventiveControl(control, controlId) {
      this.actualRisk.causas.forEach((cause, causeIndex) => {
        // Se busca si esta causa ya tiene este control asignado
        let controlIndex = -1;
        if (cause.controles_preventivos) {
          controlIndex = cause.controles_preventivos.findIndex(
            (control) => control.id === controlId
          );
        }

        // El control editado, tiene asociada esta causa?
        if (control.causas.includes(cause.id)) {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            Vue.set(
              this.actualRisk.causas[causeIndex].controles_preventivos,
              controlIndex,
              {
                ...this.actualRisk.causas[causeIndex].controles_preventivos[
                controlIndex
                ],
                nombre: control.nombre,
                critico: control.critico,
              }
            );
          } else {
            // Agregar control a causa
            const controlPreventivo = {
              id: controlId,
              nombre: control.nombre,
              critico: control.critico,
            };
            if (!this.actualRisk.causas[causeIndex].controles_preventivos) {
              Vue.set(this.actualRisk.causas, causeIndex, {
                ...this.actualRisk.causas[causeIndex],
                controles_preventivos: [],
              });
            }
            this.actualRisk.causas[causeIndex].controles_preventivos.push(
              controlPreventivo
            );
          }
          // El control editado no tiene esta causa asociada actualmente
        } else {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            // Entonces se borra
            Vue.delete(
              this.actualRisk.causas[causeIndex].controles_preventivos,
              controlIndex
            );
          }
        }
      });
    },
    addMitigationControl(impactoId, control) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        (impact) => impact.id === impactoId
      );
      if (!this.actualRisk.impactos[impactIndex].controles_mitigadores) {
        Vue.set(this.actualRisk.impactos, impactIndex, {
          ...this.actualRisk.impactos[impactIndex],
          controles_mitigadores: [],
        });
      }
      const controlMitigador = {
        id: uuid(),
        nombre: control,
      };
      this.actualRisk.impactos[impactIndex].controles_mitigadores.push(
        controlMitigador
      );
    },
    deleteMitigationControl(impactoId, controlId) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        (impact) => impact.id === impactoId
      );
      const controlIndex = this.actualRisk.impactos[
        impactIndex
      ].controles_mitigadores.findIndex((control) => control.id === controlId);
      this.dataHistory.push({
        id_inventory: this.$store.getters.inventario._id,
        action: `Se eliminó el control mitigador ${this.actualRisk.impactos[impactIndex].controles_mitigadores[controlIndex].nombre} del riesgo ${this.actualRisk.nombre}.`,
        user: this.username(),
        date: new Date(),
        type: "delete",
      });
      Vue.delete(
        this.actualRisk.impactos[impactIndex].controles_mitigadores,
        controlIndex
      );
    },
    editMitigationControl(control, controlId) {
      this.actualRisk.impactos.forEach((impact, impactIndex) => {
        // Se busca si este impacto ya tiene este control asignado
        let controlIndex = -1;
        if (impact.controles_mitigadores) {
          controlIndex = impact.controles_mitigadores.findIndex(
            (control) => control.id === controlId
          );
        }

        // El control editado, tiene asociada este impacto?
        if (control.impacto === impact.id) {
          // Este control ya existe en el impacto?
          if (controlIndex >= 0) {
            const oldValue = JSON.parse(
              JSON.stringify(
                this.actualRisk.impactos[impactIndex].controles_mitigadores[
                controlIndex
                ]
              )
            );
            Vue.set(
              this.actualRisk.impactos[impactIndex].controles_mitigadores,
              controlIndex,
              {
                ...this.actualRisk.impactos[impactIndex].controles_mitigadores[
                controlIndex
                ],
                nombre: control.nombre,
                critico: control.critico,
              }
            );
            this.dataHistory.push({
              id_inventory: this.$store.getters.inventario._id,
              action: `Se modificó el control mitigador ${oldValue.nombre
                }, ( Nombre: ${control.nombre}, Critico: ${control.critico === true ? "Si" : "No"
                }, Jerarquía de control: ${control.jerarquiaControl} ).`,
              user: this.username(),
              date: new Date(),
              type: "update",
            });
          } else {
            // Agregar control a impacto
            const controlMitigador = {
              id: uuid(),
              nombre: control.nombre,
              critico: control.critico,
            };
            this.actualRisk.impactos[impactIndex].controles_mitigadores.push(
              controlMitigador
            );
          }
          // El control editado no tiene este impacto asociada actualmente
        } else {
          // Este control ya existe en el impacto?
          if (controlIndex >= 0) {
            // Entonces se borra
            Vue.delete(
              this.actualRisk.impactos[impactIndex].controles_mitigadores,
              controlIndex
            );
          }
        }
      });
    },
    addEvaluator(pEvaluator) {
      if (!this.actualRisk.evaluadores) {
        this.actualRisk.evaluadores = [];
      }
      const evaluator = {
        ...pEvaluator,
        id: uuid(),
      };
      this.actualRisk.evaluadores.push(evaluator);
      this.dataHistory.push({
        id_inventory: this.$store.getters.inventario._id,
        action: `Se agregó un nuevo evaluador del riesgo, ${evaluator.nombre} (${evaluator.cargo}).`,
        user: this.username(),
        date: new Date(),
        type: "add",
      });
    },
    editEvaluator(evaluator, evaluadorId) {
      const evaluatorIndex = this.actualRisk.evaluadores.findIndex(
        (evaluator) => evaluator.id === evaluadorId
      );
      const oldVal = JSON.parse(
        JSON.stringify(this.actualRisk.evaluadores[evaluatorIndex])
      );
      Vue.set(this.actualRisk.evaluadores, evaluatorIndex, {
        ...this.actualRisk.evaluadores[evaluatorIndex],
        nombre: evaluator.nombre,
        rut: evaluator.rut,
        cargo: evaluator.cargo,
        empresa: evaluator.empresa,
      });
      this.dataHistory.push({
        id_inventory: this.$store.getters.inventario._id,
        action: `Se modificó un evaluador del riesgo, ${oldVal.nombre} (${oldVal.cargo}) se actualizó ha ${evaluator.nombre} (${evaluator.cargo}).`,
        user: this.username(),
        date: new Date(),
        type: "update",
      });
    },
    deleteEvaluator(evaluadorId) {
      const evaluatorIndex = this.actualRisk.evaluadores.findIndex(
        (evaluator) => evaluator.id === evaluadorId
      );
      this.dataHistory.push({
        id_inventory: this.$store.getters.inventario._id,
        action: `Se eliminó un evaluador del riesgo ${this.actualRisk.nombre}, ${this.actualRisk.evaluadores[evaluatorIndex].nombre} (${this.actualRisk.evaluadores[evaluatorIndex].cargo}).`,
        user: this.username(),
        date: new Date(),
        type: "delete",
      });
      Vue.delete(this.actualRisk.evaluadores, evaluatorIndex);
    },
    tablaControlCritico(risk) {
      if (risk.critico) {
        return "control-critico";
      }
    },
    imprimirTabla(id) {
      this.isLoadingPDFTabla = true;
      this.$store.dispatch("getPDFRiesgoTablaInv", id).then((response) => {
        this.isLoadingPDFTabla = false;
        // window.open(response);
      });
    },
    imprimirBowtie(id) {
      this.isLoadingPDFBowtie = true;
      this.$store.dispatch("getPDFRiesgoBowtieInv", id).then((response) => {
        this.isLoadingPDFBowtie = false;
      });
    },
  },
};
</script>

<style scoped>
.aprueba {
  border: 3px solid green;
  color: white;
}

.rechaza {
  border: 3px solid red;
  color: white;
}

.tabla-riesgos {
  overflow-x: auto;
}

.el-tag.big {
  font-size: 20px;
}

.el-tag--warning {
  color: rgb(61, 45, 31);
}

.statusUpdatedAt {
  font-size: 10px;
  color: gray;
}

.tag-material {
  margin-bottom: 7px;
}

.fullWidth {
  width: 100%;
}

.nombre-riesgo {
  word-break: break-word;
}

.no-aplica {
  font-size: 12px;
  color: gray;
}

.img_pdf {
  height: 30px;
  margin-bottom: 5px;
}

.button_img {
  vertical-align: middle;
  border: none;
  padding: 0;
  background-color: transparent;
  margin: 10px;
}

.text-center {
  text-align: center;
}

.yellow {
  background-color: #e4d306;
}

.green {
  background-color: #6bc45b;
}

.btn_show_history_risk {
  background-color: #e4d306;
  padding: 3px;
  padding-left: 20px;
  padding-right: 20px;
  border: none;
  color: white;
  font-size: 15px;
  border-radius: 3px;
}

.dialog_show_history_risk {
  padding-left: 20px;
  padding-right: 20px;
  margin-top: -10px;
}

.dialog_show_history_risk span.history_tag {
  border: none;
  color: white;
  border-radius: 3px;
  background-color: #dd590096;
  float: right;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: 100;
}

.color_orange {
  color: #dd5900;
}

.dialog_show_history_risk_btn_close {
  padding: 2px;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
  border-radius: 3px;
  background-color: #878787;
  font-size: 12px;
  font-weight: lighter;
  display: block;
  margin: 0 auto;
}

.HistoryRisk_container {
  width: 100%;
  overflow: auto;
}

.font-title {
  font-size: 18px;
}

.buttonAction {
  margin-top: 8px;
}

.contentTooltip {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.full-content {
  width: 100%;
}</style>
